import * as React from 'react';
import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Input": Input, "@mui/material/InputLabel": InputLabel, "@mui/material/InputAdornment": InputAdornment, "@mui/material/FormControl": FormControl, "@mui/material/TextField": TextField, "@mui/icons-material/AccountCircle": AccountCircle } } });
export default ClientProvider;
